import Parse from 'html-react-parser';

import blog from './blog.json';
import './reset.scss'
import styles from './App.module.scss';

function App() {
  const { posts } = blog;
  const categories = {
    20: 'Health and Wellness',
    8: 'TEAM News',
    21: 'Compliance and Safety',
    9: 'Industry Info'
  }
  console.log(posts)
  return (
    <div className={styles.app}>
      <header className="App-header">
      </header>
      <main className={styles.main}>
        {posts.map(post => {
          const metadata = { ...post }
          delete metadata.content;
          delete metadata.template;
          delete metadata.yoast_head;

          const date = new Date(post.date)

          function padTo2Digits(num) {
  return num.toString().padStart(2, '0');
}

function formatDate(date) {
  return (
    [
      date.getFullYear(),
      padTo2Digits(date.getMonth() + 1),
      padTo2Digits(date.getDate()),
    ].join('-') +
    ' ' +
    [
      padTo2Digits(date.getHours()),
      padTo2Digits(date.getMinutes())
    ].join(':')
  );
}

          return (
            <div key={post.id} className={styles.post}>
              <a href={post.link} target="_blank" rel="noreferrer"><h1>{post.title.rendered}</h1></a>
              <h3>Metadata</h3>
              <div className={styles.meta}>
                <div className={styles.container}>
                  <p><strong>Title:</strong> {post.title.rendered}</p>
                  <p><strong>Slug: </strong> Click Generate</p>
                  <p><strong>Article Images:</strong> (find it in uploaded images)</p>
                  <img src={post.jetpack_featured_media_url} alt="team" />
                  <p></p>
                  <p><strong>Article Description:</strong> {post.yoast_head_json.description}</p>
                  <p><strong>Publish Date:</strong> {formatDate(date)}</p>
                  <p><strong>Author Details:</strong> {post.yoast_head_json.author}</p>
                  <p><strong>Read Time:</strong>: ?</p>
                  <p><strong>Categories:</strong> {post.categories.map((category, i) => categories[category]).join(', ')}</p>
                </div>
              </div>
              <h3>Content</h3>
              <div className={styles.content}>
              {post?.content?.rendered && Parse(post.content.rendered)}
              </div>
            </div>
          )
        })}
      </main>
    </div>
  );
}

export default App;
